// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rrbhbhuscpzcaodzvfyl.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJyYmhiaHVzY3B6Y2FvZHp2ZnlsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQxMjIyNjYsImV4cCI6MjA2OTY5ODI2Nn0.nvfwKnWhUlotja4nFhB79p8uIFIhYTxeT7N_SieKMaU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});